@if (acl$ | async; as acl) {
  @if (aclParents$ | async; as aclParents) {
    @if (acl !== undefined) {
      <era-acl-permission-details [acl]="acl"
                                  [aclParents]="aclParents"
                                  (submitFormEvent)="submitFormEvent($event)"></era-acl-permission-details>
    }
  }
}